// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let Numeral = require("../../../utils/Numeral.bs.js");
let Stdlib_Option = require("@rescript/runtime/lib/js/Stdlib_Option.js");
let Stdlib_Result = require("@rescript/runtime/lib/js/Stdlib_Result.js");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");

function chain(state, validators) {
  let x = validators.map(validator => validator(state)).find(Stdlib_Result.isError);
  if (x !== undefined && x.TAG !== "Ok") {
    return {
      TAG: "Error",
      _0: x._0
    };
  } else {
    return {
      TAG: "Ok",
      _0: state
    };
  }
}

function isRequired(str) {
  let match = Stdlib_Option.map(str, v => v.trim());
  if (match !== undefined && match !== "") {
    return {
      TAG: "Ok",
      _0: str
    };
  } else {
    return {
      TAG: "Error",
      _0: "is required"
    };
  }
}

function isNotNone(x) {
  if (x !== undefined) {
    return {
      TAG: "Ok",
      _0: x
    };
  } else {
    return {
      TAG: "Error",
      _0: "is required"
    };
  }
}

function isMoreThan(formatAsPriceOpt, min, num) {
  let formatAsPrice = formatAsPriceOpt !== undefined ? formatAsPriceOpt : false;
  if (num >= min) {
    return {
      TAG: "Ok",
      _0: min
    };
  }
  let formatted = formatAsPrice ? Numeral.formatPrice(min) : min.toString();
  return {
    TAG: "Error",
    _0: "must be more than " + formatted
  };
}

function isLessThan(formatAsPriceOpt, max, num) {
  let formatAsPrice = formatAsPriceOpt !== undefined ? formatAsPriceOpt : false;
  if (num <= max) {
    return {
      TAG: "Ok",
      _0: max
    };
  }
  let formatted = formatAsPrice ? Numeral.formatPrice(max) : max.toString();
  return {
    TAG: "Error",
    _0: "must be less than " + formatted
  };
}

function validateIfNotNone(value, otherValidator) {
  if (value === undefined) {
    return {
      TAG: "Ok",
      _0: undefined
    };
  }
  let e = otherValidator(Primitive_option.valFromOption(value));
  if (e.TAG === "Ok") {
    return {
      TAG: "Ok",
      _0: value
    };
  } else {
    return {
      TAG: "Error",
      _0: e._0
    };
  }
}

exports.chain = chain;
exports.isRequired = isRequired;
exports.isNotNone = isNotNone;
exports.isMoreThan = isMoreThan;
exports.isLessThan = isLessThan;
exports.validateIfNotNone = validateIfNotNone;
/* Numeral Not a pure module */
